export class TrackStyles {
    public static readonly trackStyles = [
        {"name":"blue-white","displayName":"Blue / White","fillColor":"#FFFFFF","strokeColor":"#007dbd"},
        {"name":"red-white","displayName":"Red / White","fillColor":"#FFFFFF","strokeColor":"#FF0000"},
        {"name":"yellow-black","displayName":"Yellow / Black","fillColor":"#FFFF00","strokeColor":"rgba(0,0,0,0.5)"},
        {"name":"red-black","displayName":"Red / Black","fillColor":"#FF0000","strokeColor":"rgba(0,0,0,0.5)"}
    ];
}